<script>
  import { Router, Route } from "svelte-routing";
  import { onMount } from "svelte";
  import { auth } from "./stores/auth.js";
  import { loadConfig } from "./stores/config.js";

  // Layouts
  import Admin from "./layouts/Admin.svelte";
  import Auth from "./layouts/Auth.svelte";

  // Components
  import ProtectedRoute from "./components/ProtectedRoute.svelte";

  // Views
  import Landing from "./views/Landing.svelte";
  import Login from "./views/auth/Login.svelte";
  import Callback from "./views/auth/Callback.svelte";
  import Dashboard from "./views/admin/Dashboard.svelte";
  import Pies from "./views/admin/Pies.svelte";
  import PieDetail from "./views/admin/PieDetail.svelte";
  import PieCreate from "./views/admin/PieCreate.svelte";
  import Portfolio from "./views/admin/Portfolio.svelte";
  import Orders from "./views/admin/Orders.svelte";
  import Settings from "./views/admin/Settings.svelte";
  import Onboarding from "./views/admin/Onboarding.svelte";
  import StockDetail from "./views/admin/StockDetail.svelte";
  import Banking from "./views/admin/Banking.svelte";
  import Documents from "./views/admin/Documents.svelte";
  import Activities from "./views/admin/Activities.svelte";
  import Terms from "./views/Terms.svelte";
  import Privacy from "./views/Privacy.svelte";

  export let url = "";

  onMount(() => {
    // Load app configuration from backend
    loadConfig();
    // Initialize auth
    auth.init();
  });
</script>

<Router {url}>
  <!-- Landing page -->
  <Route path="/" component={Landing} />
  
  <!-- Legal pages (public) -->
  <Route path="/terms" component={Terms} />
  <Route path="/privacy" component={Privacy} />

  <!-- Auth routes -->
  <Route path="/auth/login">
    <Auth>
      <Login />
    </Auth>
  </Route>
  
  <Route path="/auth/callback">
    <Auth>
      <Callback />
    </Auth>
  </Route>

  <!-- Admin routes (protected) -->
  <Route path="/admin/dashboard">
    <ProtectedRoute requiresAlpaca={false}>
      <Admin><Dashboard /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/pies">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><Pies /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/pies/new">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><PieCreate /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/pies/:id" let:params>
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><PieDetail id={params.id} /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/portfolio">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><Portfolio /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/orders">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><Orders /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/banking">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><Banking /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/documents">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><Documents /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/activities">
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><Activities /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/settings">
    <ProtectedRoute requiresAlpaca={false}>
      <Admin><Settings /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/onboarding">
    <ProtectedRoute requiresAlpaca={false}>
      <Admin><Onboarding /></Admin>
    </ProtectedRoute>
  </Route>

  <Route path="/admin/stock/:symbol" let:params>
    <ProtectedRoute requiresAlpaca={true}>
      <Admin><StockDetail symbol={params.symbol} /></Admin>
    </ProtectedRoute>
  </Route>
</Router>